import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificariService {
    private basePath = environment.interop.basePath;

    public downloadEmailUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.notificari.email.downloadEmail;
    private resendEmailUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.notificari.email.resendEmail;
    private printNotificariEmailUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.notificari.email.printNotificari;

    private resendSmsUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.notificari.sms.resendSMS;
    private printNotificariSmsUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.notificari.sms.printNotificari;

    constructor(private http: HttpClient) { }

    resendEmail(id: number) {
        return this.http.post(this.resendEmailUrl + id, {});
    }

    resendSms(id: number) {
        return this.http.post(this.resendSmsUrl + id, {});
    }

    printNotificariEmail(payload: any) {
        return this.http.post(this.printNotificariEmailUrl, payload, { responseType: 'blob' as 'json' });
    }

    printNotificariSms(payload: any) {
        return this.http.post(this.printNotificariSmsUrl, payload, { responseType: 'blob' as 'json' });
    }
}
